const session_expired = {
    title: 'La sessione è scaduta',
    subtitle: 'La tua sessione potrebbe essere scaduta e sei stato disconnesso. Clicca il pulsante qui sotto per accedere di nuovo alla console di amministrazione.',
    button: 'Accedi di nuovo',
};
export default Object.freeze(session_expired);
